import Link from 'next/link'
import React from 'react'
import { Breadcrumb, BreadcrumbItem, Container } from 'react-bootstrap'
import { useState } from 'react';
import { GetCmsPages } from '../api.services.js/others';
import Head from 'next/head';


const Thankyou = (props) => {
  
  return (
    <div class="col-sm-12 text-center parentbg">
<div class="maindiv bgimg">
<div style={{padding:"100px 0px"}}><img src="https://server.orientbell.com/media/wysiwyg/whitelogo.png" alt="logo"/>
<h1 style={{color:"white !important", margin:"15px"}}>THANK YOU</h1>
<p style={{color:"white !important"}}>Our team will call you shortly</p>
</div>

</div>
</div>
  )
}

export default Thankyou
